
import { Suspense, lazy } from "react";
import './App.css';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import TopHeader from './Component/Home/TopHeader';
import Footer from './Component/Footer';
import ScrollToTop from './Component/ScrollToTop';

const Home = lazy(() => import("./Component/Home/Home"));
const About = lazy(() => import("./Component/About/About"));
const RazorpayButton = lazy(() => import("./Component/Home/RazorpayButton "));
const Donate = lazy(() => import("./Component/Payment/Donate"));
const CommingEvent = lazy(() => import("./Component/UpcommingEvent/CommingEvent"));
const KanyaVivah = lazy(() => import("./Component/ResolutionsServices/KanyaVivah/KanyaVivah"));
const CancerHospital = lazy(() => import("./Component/ResolutionsServices/CancerHospital/CancerHospital"));
const GuaRaksha = lazy(() => import("./Component/ResolutionsServices/GuaRaksha/GuaRaksha"));
const VedicGurukul = lazy(() => import("./Component/ResolutionsServices/VedicGurukul/VedicGurukul"));
const AnnapurnaRasoi = lazy(() => import("./Component/ResolutionsServices/AnnapurnaRasoi.jsx/AnnapurnaRasoi"));
const ContactUs = lazy(() => import("./Component/Contact/ContactUs"));
const VisitDham = lazy(() => import("./Component/VisitDham/VisitDham"));
const AllReels = lazy(() => import("./Component/Home/AllReels"));
const AllVideos = lazy(() => import("./Component/Home/AllVideos"));
const OorjaDetails = lazy(() => import("./Component/Home/OorjaDetails"));
const PrivacyPolicy = lazy(() => import("./Component/LegalInformation/PrivacyPolicy"));
const TermofService = lazy(() => import("./Component/LegalInformation/TermofService"));

// Helper to handle chunk loading errors
const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    try {
      return await componentImport();
    } catch (error) {
      console.error("Chunk loading failed, reloading...", error);
      window.location.reload();
      return { default: () => null };
    }
  });

const GurudevProgramDetails = lazyWithRetry(() => import("./Component/Home/GurudevProgramDetails"));


function App() {
  return (
   <>
  
   <Router>
    <ScrollToTop />
     <TopHeader />
     <Suspense fallback={<div className="route-loading">Loading...</div>}>
       <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/about" element={<About />} />
         <Route path="/razorpaybutton" element={<RazorpayButton />} />
         <Route path="/donate" element={<Donate />} />
         <Route path="/commingevent" element={<CommingEvent />} />
         <Route path="/kanyavivah" element={<KanyaVivah />} />
         <Route path="/cancerhospital" element={<CancerHospital />} />
         <Route path="/guaraksha" element={<GuaRaksha />} />
         <Route path="/vedicgurukul" element={<VedicGurukul />} />
         <Route path="/annapurnarasoi" element={<AnnapurnaRasoi />} />
         <Route path="/contactus" element={<ContactUs />} />
         <Route path="/visitdham" element={<VisitDham />} />
         <Route path="/all-reels" element={<AllReels />} />
         <Route path="/all-videos" element={<AllVideos />} />
         <Route path="/oorja-details" element={<OorjaDetails />} />
         <Route path="/program-details/:id" element={<GurudevProgramDetails />} />
         <Route path="/privacypolicy" element={<PrivacyPolicy />} />
         <Route path="/termsofservice" element={<TermofService />} />
       </Routes>
     </Suspense>
       <Footer />
   </Router>
   </>
  );
}

export default App;

   
